<template>
  <a href="#" class="logo" @click="scrollToTop">
    <img v-if="screen === 'top'" src="../assets/img/logo_przedruk.svg" alt="przeDruk Logo" />
    <img v-else src="../assets/img/logo_przedruk-1.svg" alt="przeDruk Logo" />
  </a>
</template>

<script>
import { bus } from "../main";
export default {
  name: "TheLogo",
  props: {
    screen: String
  },
  methods: {
    scrollToTop: function(e) {
      e.preventDefault();
      bus.$emit("hidePP");
      bus.$emit("hidePost");
    }
  }
};
</script>

<style lang="scss">
section .logo {
  position: absolute;
}

.logo {
  position: fixed;
  z-index: 10;
  top: $screen-gutter-top;
  left: $screen-gutter-left;

  &:focus {
    outline: none;
  }
}
</style>